<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/modules/authStore/stores/authStore'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'
import { logtoClient } from '@/plugins/logto'

const router = useRouter()
const authStore = useAuthStore()
const feedbackStore = useFeedbackStore()
const errorMessage = ref('')
const isLoading = ref(false)
const exchanged = ref(false)

async function completeLogin() {
  if (isLoading.value) return
  isLoading.value = true
  feedbackStore.isGlobalLoading = true
  errorMessage.value = ''
  try {
    if (!logtoClient) throw new Error('SSO unavailable')
    if (!exchanged.value) {
      // Always complete a real callback, even if an old ID token is present.
      if (await logtoClient.isSignInRedirected(window.location.href)) {
        await logtoClient.handleSignInCallback(window.location.href)
      } else if (!await logtoClient.isAuthenticated()) {
        throw new Error('Sign-in session missing')
      }
      exchanged.value = true
      await router.replace('/callback')
    }
    if (await authStore.restoreAuth()) {
      const { consumeEquipmentTarget } = await import('@/modules/equipment/returnTarget')
      await router.replace(consumeEquipmentTarget() || '/')
    } else {
      errorMessage.value = authStore.sessionError ?? 'Не удалось завершить вход. Попробуйте войти снова.'
    }
  } catch {
    errorMessage.value = 'Не удалось завершить вход. Проверьте подключение и повторите попытку.'
  } finally {
    isLoading.value = false
    feedbackStore.isGlobalLoading = false
  }
}

onMounted(completeLogin)
</script>

<template>
  <div
    v-if="errorMessage"
    class="d-flex align-center justify-center flex-column"
    style="height: 100vh; width: 100vw;"
  >
    <VIcon
      icon="ri-error-warning-line"
      size="48"
      color="error"
    />
    <h1 class="text-body-1 text-error mt-4 mb-4">
      {{ errorMessage }}
    </h1>
    <VBtn
      v-if="exchanged"
      color="primary"
      class="mb-3"
      @click="completeLogin"
    >
      Повторить подключение
    </VBtn>
    <VBtn
      color="primary"
      prepend-icon="ri-arrow-left-line"
      @click="router.push('/login')"
    >
      Вернуться к входу
    </VBtn>
  </div>
</template>
